import React from 'react';
import { MediaQueueTile } from '@cube3/ui/src/Prefabs/MediaQueue/MediaQueueTile';
import Thumbnail from '@cube3/ui/src/thumbnails/Thumbnail';
import Time from '@cube3/cubicle/src/core/utility/Time';
import { LibraryItemOverlay } from '@cube3/ui/src/library/LibraryItemOverlay';
import fileImage from '@cube3/ui/src/assets/images/Library/file.svg?url';
import { Shimmer } from '@cube3/cubicle/src/core/atoms/Loader/Shimmer';
import { UploadBreadcrumbs } from '../UploadBreadcrumbs';
import { useUploadActions } from '../../hooks/useUploadActions';

export const UploadQueueListItemNoAsset = ({ upload }) => {
  const { onClickRemoveUpload } = useUploadActions({
    upload,
    asset: undefined
  });

  return (
    <li style={{ listStyle: 'none' }}>
      <MediaQueueTile
        thumb={
          <LibraryItemOverlay
            back={
              <Thumbnail src={upload.display_image || fileImage} cover={false} ratio="sixteenToNine" />
            }
          />
        }
        title={upload?.display_name || 'loading'}
        contextRow={<UploadBreadcrumbs />}
        timestampRow={
          (upload && (
            <span>
              Last activity <Time date={upload?.updated_at} />
            </span>
          )) || <Shimmer width={120} height={20} />
        }
        status={upload.failed ? 'failed' : 'pending'}
        statusLabel={upload.failed ? 'Never started' : 'Waiting to upload'}
        statusProgress={undefined}
        onCloseClick={upload.failed ? onClickRemoveUpload : undefined}
      />
    </li>
  );
};
